import type { ReactNode } from "react";

/**
 * Редът с проверката на номера под полето — общ за „Смяна на маса", „Нова
 * маса" и „Към друга маса" (разделяне), за да изглеждат еднакво: фин
 * центриран текст без кутия; заета маса/отказ — червено, непроверено (без
 * връзка) — в акцента, подсказка — приглушено.
 */
export function TableCheckLine({
  tone,
  children,
}: {
  tone: "error" | "warning" | "hint";
  children: ReactNode;
}) {
  const color =
    tone === "error"
      ? "text-pos-danger-ink"
      : tone === "warning"
        ? "text-pos-accent-ink"
        : "text-pos-soft";
  return (
    <div
      role={tone === "error" ? "alert" : tone === "warning" ? "status" : undefined}
      className={`-mt-1 text-center text-[12.5px] font-medium leading-[1.45] ${color}`}
    >
      {children}
    </div>
  );
}
